export const hasAccess = (requiredRoles = [], userRoles = []) => {
  const hasAccess = userRoles.find(r => requiredRoles.includes(r))
  return hasAccess ? true : false
}
